var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasSuggestions)?_c('ul',{attrs:{"id":"suggestions"}},_vm._l((_vm.suggestions),function(suggestion,index){return _c('li',{key:index},[_vm._v(_vm._s(suggestion))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }